// extracted by mini-css-extract-plugin
module.exports = {"cardPadding":"EligibilityConfiguration-module__cardPadding___3e45r","marginLeft":"EligibilityConfiguration-module__marginLeft___1zez7"};